import { render } from "./AnimatedBg.vue?vue&type=template&id=252a9e1e&scoped=true&ts=true"
import script from "./AnimatedBg.vue?vue&type=script&lang=ts"
export * from "./AnimatedBg.vue?vue&type=script&lang=ts"

import "./AnimatedBg.vue?vue&type=style&index=0&id=252a9e1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252a9e1e"]])

export default __exports__